import type { WeakTopic } from "@/hooks/useStudentDashboard";
import {useAiCoach} from "@/hooks/useAiCoach";
import EmptyState from "./EmptyState";

interface WeakTopicsListProps {
  weakTopics: WeakTopic[];
  loading: boolean;
}

export default function WeakTopicsList({ weakTopics, loading }: WeakTopicsListProps) {
  const { openCoach } = useAiCoach();

  if (loading) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Eksik Konular</h3>
        <div className="mt-4 space-y-2">
          <div className="h-10 rounded-md bg-background-100 animate-pulse" />
          <div className="h-10 rounded-md bg-background-100 animate-pulse" />
        </div>
      </div>
    );
  }

  if (weakTopics.length === 0) {
    return (
      <EmptyState
        icon="ri-line-chart-line"
        title="Henüz analiz verisi yok"
        description="Geliştirmen gereken konular, çözdüğün sorular ve denemeler analiz edildikçe burada listelenecek."
      />
    );
  }

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-base text-foreground-950">Eksik Konular</h3>
        <span className="text-xs text-foreground-500">çalışman önerilir</span>
      </div>

      <ul className="mt-4 space-y-3">
        {weakTopics.map((t) => (
          <li key={t.id}>
            <div className="flex items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground-800 truncate">{t.topic}</p>
                <p className="text-xs text-foreground-500">{t.subject}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <button
                  type="button"
                  onClick={() =>
                    openCoach(
                      `Bana "${t.topic}" konusunu (${t.subject}) en baştan, adım adım ve örneklerle öğret. Bu konuda eksiklerim var.`,
                    )
                  }
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-700 hover:text-accent-800 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-graduation-cap-line" aria-hidden="true"></i>
                  Bu Konuyu Öğren
                </button>
                <span className="text-xs font-semibold text-foreground-700 whitespace-nowrap">
                  %{t.mastery_percent}
                </span>
              </div>
            </div>
            <div className="mt-1.5 h-1.5 rounded-full bg-background-100 overflow-hidden">
              <div
                className={`h-full rounded-full ${
                  t.mastery_percent < 40 ? "bg-accent-500" : t.mastery_percent < 70 ? "bg-secondary-500" : "bg-primary-500"
                }`}
                style={{ width: `${t.mastery_percent}%` }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}